import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface LocationResponse {
    loc_code?: string | null;
    loc_desc?: string | null;
    loc_active?: boolean | number | null;
    loc_remote?: boolean | number | null;
}

export const getLocations = async (): Promise<LocationResponse[]> => {
    try {
        const response: ApiResponse<LocationResponse[]> = (
            await apiClient.get("/pos_loc")
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch locations");
    }
};

export const getLocationByCode = async (locCode: string): Promise<LocationResponse> => {
    try {
        const response: ApiResponse<LocationResponse | null> = (
            await apiClient.get(`/pos_loc/${encodeURIComponent(locCode)}`)
        ).data;

        if (!response.data) {
            throw new Error(`Location ${locCode} not found`);
        }

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error(`Failed to fetch location ${locCode}`);
    }
};
